import { useTranslate } from "ra-core";

import { CalendarPage } from "@/components/fretum/calendar/CalendarPage";

import { morphTriggerSelector } from "../layout/closeButtonPlacement";
import { useMobileChrome } from "../layout/MobileChrome";
import { MorphWindow } from "../layout/MorphWindow";

/**
 * The full calendar (week / month / agenda views, picked with the segmented
 * control) as a full-screen window grown from the top-bar calendar button.
 * Opening an item or creating an event changes the route, which closes it.
 */
export const AgendaWindow = () => {
  const translate = useTranslate();
  const { activeWindow, closeWindow } = useMobileChrome();

  return (
    <MorphWindow
      open={activeWindow === "agenda"}
      onClose={closeWindow}
      trigger={morphTriggerSelector("agenda")}
      title={translate("crm.mobile.calendar")}
      closeLabel={translate("crm.mobile.calendar_window.close")}
      testId="mobile-agenda-window"
    >
      <CalendarPage embedded />
    </MorphWindow>
  );
};
